var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_122853)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#E9F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 38.2475V55.2675M55.5 38.2475V55.2675M47 38.2475V55.2675M37 38.2475V55.2675M58.5 55.2505H25.5C24.9696 55.2505 24.4609 55.4612 24.0858 55.8363C23.7107 56.2114 23.5 56.7201 23.5 57.2505V59.2505C23.5 59.781 23.7107 60.2897 24.0858 60.6647C24.4609 61.0398 24.9696 61.2505 25.5 61.2505H58.5C59.0304 61.2505 59.5391 61.0398 59.9142 60.6647C60.2893 60.2897 60.5 59.781 60.5 59.2505V57.2505C60.5 56.7201 60.2893 56.2114 59.9142 55.8363C59.5391 55.4612 59.0304 55.2505 58.5 55.2505ZM40.08 24.7995L24.54 33.2995C24.2254 33.4716 23.9629 33.7252 23.7799 34.0336C23.597 34.342 23.5003 34.6939 23.5 35.0525V37.0465C23.5 37.2041 23.531 37.3601 23.5913 37.5057C23.6517 37.6513 23.74 37.7836 23.8515 37.895C23.9629 38.0065 24.0952 38.0949 24.2408 38.1552C24.3864 38.2155 24.5424 38.2465 24.7 38.2465H59.3C59.4576 38.2465 59.6136 38.2155 59.7592 38.1552C59.9048 38.0949 60.0371 38.0065 60.1485 37.895C60.26 37.7836 60.3484 37.6513 60.4087 37.5057C60.469 37.3601 60.5 37.2041 60.5 37.0465V35.0525C60.4999 34.6938 60.4033 34.3416 60.2203 34.033C60.0374 33.7244 59.7747 33.4707 59.46 33.2985L43.92 24.7995C43.3313 24.4774 42.671 24.3086 42 24.3086C41.329 24.3086 40.6687 24.4774 40.08 24.7995Z",
    stroke: "#0069FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_122853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4c1ed1983cf644890c14c21c27e3d144.svg";
export { ForwardRef as ReactComponent };